(function(){
  'use strict';
  if(window.__TangibleCartUpsellSizePickerV2)return;
  window.__TangibleCartUpsellSizePickerV2=true;

  function setOpen(card,open){
    if(!card)return;
    var panel=card.querySelector('[data-tgcv5-upsell-panel]');
    if(!panel||panel.hidden===!open)return;
    panel.hidden=!open;
    card.querySelectorAll('[data-tgcv5-upsell-toggle]').forEach(function(button){button.setAttribute('aria-expanded',open?'true':'false')});
    if(open){
      var first=panel.querySelector('.tgcv5-upsell-size:not(:disabled)');
      if(first)requestAnimationFrame(function(){first.focus({preventScroll:true})});
    }
  }

  function closeAll(except){
    document.querySelectorAll('[data-tgcv5-upsell-panel]:not([hidden])').forEach(function(panel){
      var card=panel.closest('[data-tgcv5-upsell-card]');
      if(card&&card!==except)setOpen(card,false);
    });
  }

  window.addEventListener('click',function(event){
    if(!(event.target instanceof Element))return;
    var size=event.target.closest('.tgcv5-upsell-size[data-tgcv5-upsell-add]');
    if(!size||size.disabled)return;
    var grid=size.closest('.tgcv5-upsell-size-grid');
    if(!grid)return;
    grid.querySelectorAll('.tgcv5-upsell-size').forEach(function(button){
      var selected=button===size;
      button.classList.toggle('is-selected',selected);
      button.setAttribute('aria-pressed',selected?'true':'false');
    });
  },true);

  document.addEventListener('click',function(event){
    if(!(event.target instanceof Element))return;
    var toggle=event.target.closest('[data-tgcv5-upsell-toggle]');
    if(toggle){
      event.preventDefault();event.stopPropagation();
      var card=toggle.closest('[data-tgcv5-upsell-card]');
      var panel=card&&card.querySelector('[data-tgcv5-upsell-panel]');
      var willOpen=Boolean(panel&&panel.hidden);
      closeAll(card);setOpen(card,willOpen);return;
    }
    var close=event.target.closest('[data-tgcv5-upsell-close]');
    if(close){event.preventDefault();event.stopPropagation();setOpen(close.closest('[data-tgcv5-upsell-card]'),false);return}
    if(!event.target.closest('[data-tgcv5-upsell-card]'))closeAll();
  },true);

  document.addEventListener('keydown',function(event){
    if(event.key!=='Escape')return;
    var panel=document.querySelector('[data-tgcv5-upsell-panel]:not([hidden])');
    if(!panel)return;
    event.preventDefault();
    var card=panel.closest('[data-tgcv5-upsell-card]');
    setOpen(card,false);
    var trigger=card&&card.querySelector('[data-tgcv5-upsell-toggle]');
    if(trigger)trigger.focus({preventScroll:true});
  });

  document.addEventListener('cart:updated',function(){closeAll()});
  document.addEventListener('shopify:section:load',function(){closeAll()});
})();

